import { markNavigation } from './RouterLink';

/**
 * Safari (iOS edge swipe) and Chrome animate back/forward themselves. Our own
 * view transition would play the animation a second time (#162), so a
 * `popstate` marks the change as `native`, which the CSS leaves unanimated.
 * Where `hasUAVisualTransition` is missing, a recent touch that began at the
 * screen edge counts as the swipe.
 */
const EDGE_PX = 32;
let edgeTouchAt = -Infinity;

export function installNativeBackGuard(target: Window = window) {
  const onTouch = (e: TouchEvent) => {
    const x = e.touches[0]?.clientX ?? Infinity;
    if (x <= EDGE_PX || x >= target.innerWidth - EDGE_PX) edgeTouchAt = performance.now();
  };
  const onPop = (e: PopStateEvent) => {
    const flagged = (e as PopStateEvent & { hasUAVisualTransition?: boolean })
      .hasUAVisualTransition;
    const swipe = flagged ?? performance.now() - edgeTouchAt < 1500;
    markNavigation(swipe ? 'native' : 'fade');
  };
  target.addEventListener('touchstart', onTouch, { passive: true });
  target.addEventListener('popstate', onPop);
  return () => {
    target.removeEventListener('touchstart', onTouch);
    target.removeEventListener('popstate', onPop);
  };
}
